export default __webpack_public_path__ + "static/media/high-voltage-purple.1dbe3e83.png";